module.exports = __webpack_public_path__ + "static/media/07_MEDS-1.7-C-10 1.af7e65c1.svg";